<div class="flex--column">
  <!-- Automatic Advice Section -->
  <div class="container">
    <h2>{{ 'controlRoom.nexusTitle' | translate }}</h2>

    <!-- Reset Automatic Advice For All Customers -->
    <div>
      <h3>{{ 'controlRoom.resetAutomaticAdviceForAllCustomers.title' | translate }}</h3>
      <div class="spacing--margin-horizontal reset-automatic-advice-container">
        <button
          type="button"
          mat-flat-button
          color="primary"
          (click)="resetAutomaticAdviceForAllCustomers()"
        >
          <mat-icon>settings_backup_restore</mat-icon>
          {{ 'controlRoom.resetAutomaticAdviceForAllCustomers.buttonText' | translate }}
        </button>
        <div class="usage-note-container">
          <div class="usage-note">
            <mat-icon class="usage-note__icon" aria-hidden="true">info</mat-icon>
            <span
              class="usage-note__text"
              [innerHTML]="'controlRoom.resetAutomaticAdviceForAllCustomers.usageNote' | translate"
            ></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Upload CSV File -->
    <div>
      <h3>{{ 'automaticAdvice.titleText' | translate }}</h3>
      <div class="spacing--margin-horizontal csv-buttons-container">
        <button
          class="hero-button"
          type="button"
          mat-stroked-button
          (click)="file.click()"
          data-test="file-button"
        >
          <img src="../../assets/images/roller_skating.svg" alt="select_file_button" />
          <span class="file-name-ellipsis">
            {{ selectedFile ? selectedFile.name : ('automaticAdvice.selectFile' | translate) }}
          </span>
        </button>

        <input
          hidden
          (change)="onFileSelected()"
          #file
          type="file"
          accept=".csv"
          data-test="file-input"
        />

        <button
          mat-raised-button
          color="primary"
          class="upload-button"
          (click)="automaticAdvice()"
          [disabled]="!selectedFile"
        >
          {{ 'automaticAdvice.uploadButtonText' | translate }}
        </button>
      </div>
    </div>

    <!-- Set Automatic Advice Customers Preferences -->
    <div>
      <h3>{{ 'controlRoom.automaticAdviceCustomersPreferences.sectionTitle' | translate }}</h3>
      <p>{{ 'controlRoom.automaticAdviceCustomersPreferences.description' | translate }}</p>
      <button
        type="button"
        mat-flat-button
        color="purple"
        class="spacing--margin-horizontal"
        (click)="setAutomaticAdviceCustomersPreferences()"
      >
        <mat-icon>brightness_auto</mat-icon>
        {{ 'controlRoom.automaticAdviceCustomersPreferences.buttonText' | translate }}
      </button>
      <span>{{ 'controlRoom.automaticAdviceCustomersPreferences.lastUpdate' | translate }}</span>
      <span>
        @if (lastAutomaticAdviceCustomersPreferencesUpdate$ | async; as lastUpdate) {
          {{ lastUpdate | agrDate: 'dd MMM yyyy, HH:mm' }}
        } @else {
          {{ 'controlRoom.automaticAdviceCustomersPreferences.lastUpdateNotAvailable' | translate }}
        }
      </span>
    </div>

    <!-- Scheduler -->
    <div>
      <app-automatic-flow-scheduler
        [enabledState]="enabledAdviceState$ | async"
        [schedulerType]="automaticSchedulerType.advice"
        [loading]="loadingAdvice$ | async"
        (activate)="activateScheduler($event)"
        (activateNow)="triggerAutomaticAdvice()"
        (stop)="disableScheduler($event)"
      />
    </div>
  </div>

  <mat-divider />

  <!-- BBA Section -->
  <div class="container">
    <h2>{{ 'controlRoom.bbaTitle' | translate }}</h2>

    <!-- Recalculate BBA -->
    <div class="recalculatebba-section">
      <h3>{{ 'controlRoom.recalculateBBA.title' | translate }}</h3>
      <p>{{ 'controlRoom.recalculateBBA.description' | translate }}</p>
      <button
        type="button"
        mat-flat-button
        color="purple"
        class="spacing--margin-horizontal"
        (click)="triggerBbaRecalculation()"
        [disabled]="loadingBbaRecalculation$ | async"
      >
        <mat-icon>favorite</mat-icon>
        {{ 'controlRoom.recalculateBBA.buttonText' | translate }}
      </button>
    </div>

    <mat-divider />

    <!-- Automatic CropField Export -->
    <div>
      <app-automatic-flow-scheduler
        [enabledState]="enabledExportState$ | async"
        [schedulerType]="automaticSchedulerType.exportFertilizationBalanceDataFertilab"
        [loading]="loadingExport$ | async"
        (activate)="activateScheduler($event)"
        (activateNow)="triggerAutomaticCropFieldExport()"
        (stop)="disableScheduler($event)"
      />
    </div>

    <mat-divider />

    <!-- Automatic CropField Order -->
    <div>
      <app-automatic-flow-scheduler
        [enabledState]="enabledOrderState$ | async"
        [schedulerType]="automaticSchedulerType.order"
        [loading]="loadingOrder$ | async"
        (activate)="activateScheduler($event)"
        (activateNow)="triggerAutomaticCropFieldOrder()"
        (stop)="disableScheduler($event)"
      />
    </div>
  </div>
</div>
